import { EVENT_KEY_RE, MAX_EXTRA_KEYS, PAYLOAD_KEY_RE, REQUIRED_PAYLOAD_KEYS } from "./domain-event.constants";
import { sourceOf } from "./domain-event.utils";

// Mirrors RemDomainEventCtl.normalize in the backend (reminder_setup/domain_event/controller.js).
export const domainEventValidation = {
  event_key: (value) => {
    const key = String(value ?? "").trim();
    if (!key) return "";
    return EVENT_KEY_RE.test(key) && key.length <= 100 ? "" : "Use module.happening in lowercase, e.g. project.status_changed.";
  },
  name: (value) => (String(value ?? "").trim().length > 100 ? "Name must be at most 100 characters." : ""),
  // A saved event may keep an archived source; a new choice may not.
  source_fid: (value, formData, dependencies) => {
    const source = sourceOf({ source_fid: value }, dependencies);
    return source?.status === "ARCHIVED" && formData.source?.id !== value ? "This source is archived; pick another one." : "";
  },
  sort_order: (value) => {
    if (value === "" || value === null || value === undefined) return "";
    const number = Number(value);
    return Number.isInteger(number) && number >= 0 && number <= 10000 ? "" : "Sort order must be a whole number from 0 to 10000.";
  },
  payload_schema: (value) => {
    const rows = Array.isArray(value) ? value : [];
    if (rows.length > MAX_EXTRA_KEYS) return `At most ${MAX_EXTRA_KEYS} extra keys.`;
    const seen = new Set();
    for (const row of rows) {
      const key = String(row.key ?? "").trim();
      if (!PAYLOAD_KEY_RE.test(key)) return `"${key || "(empty)"}": a key starts with a lowercase letter and uses only a-z, 0-9 and _ (max 50).`;
      if (REQUIRED_PAYLOAD_KEYS.includes(key)) return `${key} is always included; remove it from the extra keys.`;
      if (seen.has(key)) return `${key} is listed twice.`;
      if (String(row.label ?? "").trim().length > 100) return `${key}: the label must be at most 100 characters.`;
      seen.add(key);
    }
    return "";
  },
};
